(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  function showAll() {
    observer?.disconnect();
    document.querySelectorAll('.cj-motion-pending').forEach(el => el.classList.remove('cj-motion-pending'));
  }
  function init(scope = document) {
    if (reduced.matches || document.body.hasAttribute('data-reduce-animations') || window.Shopify?.designMode || !('IntersectionObserver' in window)) { showAll(); return; }
    try {
      observer ||= new IntersectionObserver(entries => entries.forEach(({target, isIntersecting}) => {
        if (isIntersecting) { target.classList.remove('cj-motion-pending'); observer.unobserve(target); }
      }), {threshold:0.08, rootMargin:'0px 0px 32px 0px'});
      scope.querySelectorAll('.cj-section-heading, .cj-needs-grid > *, .cj-category-grid > *, .cj-x7__copy, .cj-why-photo, .cj-why-intro, .cj-reasons > *, .cj-service-details > *, .cj-blog-grid > *, .cj-faq-list').forEach((el, i) => {
        if (el.classList.contains('cj-motion-ready') || el.getBoundingClientRect().top < innerHeight || el.contains(document.activeElement)) return;
        el.style.setProperty('--cj-enter-delay', `${Math.min(i % 4, 3) * 45}ms`);
        el.classList.add('cj-motion-ready', 'cj-motion-pending'); observer.observe(el);
      });
    } catch { showAll(); }
  }
  document.addEventListener('toggle', event => {
    if (!event.target.matches?.('.cj-nav-dropdown') || !event.target.open) return;
    const nav = event.target.closest('nav');
    nav?.querySelectorAll('.cj-nav-dropdown[open]').forEach(el => { if (el !== event.target) el.open = false; });
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const focused = document.activeElement?.closest('.cj-nav-dropdown[open]');
    const open = focused || document.querySelector('.cj-inline-navigation .cj-nav-dropdown[open]');
    if (open) { event.preventDefault(); open.open = false; open.querySelector('summary').focus(); }
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.cj-nav-dropdown[open]').forEach(el => {
      if (!el.contains(event.target) || event.target.closest('a[href]')) el.open = false;
    });
  });
  document.addEventListener('focusin', event => {
    event.target.closest('.cj-motion-pending')?.classList.remove('cj-motion-pending');
    document.querySelectorAll('.cj-inline-navigation .cj-nav-dropdown[open]').forEach(el => { if (!el.contains(event.target)) el.open = false; });
  });
  reduced.addEventListener('change', () => reduced.matches ? showAll() : init());
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', showAll);
  window.addEventListener('beforeprint', showAll);
  init();
})();
